const keys = {
  baseUrl: process.env.REACT_APP_BASE_URL
}

export default keys;
